import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';


const initialState = {
  isLoading: false,
  channels: [{ type: 'callus', priority: '1' }, { type: 'community', priority: '2' }, { type: 'email', priority: '3' }],
  error: false,
  display: Page.isValidToDisplayContactOptions(),
  reachToResult: false,
  emailSelected: false,
  IDIEnable: false,
  IDIChannels: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_DATA:
      return Object.assign({}, state, { isLoading: true });
    case types.RECEIVE_TOPIC_DATA_ERROR:
      return Object.assign({}, state, { isLoading: false, error: true, display: true, channels: initialState.channels.filter(channel => channel.type !== 'email') });
    case types.RECEIVE_TOPIC_DATA_RESPONSE:
      return Object.assign({}, state, { isLoading: false, error: false, display: true, channels: [...action.payload] });
    case types.REQUEST_IDI_CONTACT_OPTIONS:
      return Object.assign({}, state, { IDIEnable: true, IDIChannels: [] });
    case types.RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE:
      return Object.assign({}, state, { IDIChannels: [...action.payload] });
    case types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR:
      return Object.assign({}, state, { IDIEnable: false });
    case types.RECEIVE_CONTACT_CHANNELS_NO_DATA:
      return Object.assign({}, state, { channels: [...action.payload] });
    case types.SELECT_TOPIC_L1:
    case types.SELECT_TOPIC_L2:
    case types.SELECT_TOPIC_L3:
    case types.SELECT_TOPIC_RESET:
      return Object.assign({}, state, { channels: initialState.channels, display: initialState.display, reachToResult: false });
    case types.SELECT_RESULT:
      return Object.assign({}, state, { reachToResult: true });
    case types.REQUEST_CALLUS :
      return Object.assign({}, state, { display: false, reachToResult: false });
    case types.REQUEST_BY_EMAIL:
    case types.RECEIVE_EMPTY_FIELDS:
      return Object.assign({}, state, { display: false, reachToResult: false, emailSelected: true });
    case types.LOGIN: {
      return Object.assign({}, state, { display: Page.isValidToDisplayContactOptions(state.reachToResult, state.emailSelected) });
    }
    case types.CHANGE_TOPIC:
      return Object.assign({}, state, { display: initialState.display });
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      // Reset contact options for cancel the email selection in the bypass email page
      // reassign reachToResult for ByPass topic tree reach to end, to avoid using IDI contact options
      return Object.assign({}, state, { channels: initialState.channels, reachToResult: false });
    case types.CANCEL_EMAIL_FORM:
      return Object.assign({}, state, { display: true, reachToResult: true, emailSelected: false });

    default:
      return state;
  }
}
